import api from 'api';

export const uploadFile = (params) =>
  api('POST /api/io/upload')(params, {
    headers: {
      'Content-Type': null,
    },
  });
